import TournamentCard from "../../../../ReusableComponent/LiveTournamentCard";

const LiveSection = () => {
  const tournaments = [
    {
      title: "Weekly Algorithm Challenge",
      status: "Live Now",
      statusType: "danger",
      timeInfo: "Ends in 2 hours 15 min",
      participants: 1847,
      prize: "$5,000",
      problems: "4 challenges",
      difficulty: "Medium",
      buttonText: "Join Contest",
      buttonLink: "/tournament/weekly-algorithm-challenge",
    },
    {
      title: "Speed Coding Championship",
      status: "Starting Soon",
      statusType: "warning",
      timeInfo: "Starts in 30 minutes",
      participants: 923,
      prize: "$3,000",
      problems: "3 challenges",
      difficulty: "Hard",
      buttonText: "Register Now",
      buttonLink: "/tournament/speed-coding-championship",
    },
  ];

  return (
    <section className="row mx-0 py-5 d-flex justify-content-center align-items-center ">
      <div className="col-md-11 col-12">
        <div className="row mx-0 d-flex justify-content-center align-items-center">
          <div className="col-12 text-center mb-3">
            <h2 className="text-light fw-bold mb-4">
              Live & Upcoming Tournaments
            </h2>
          </div>
        
            {tournaments.map((t, index) => (
              <TournamentCard key={index} {...t} />
            ))}
         
        </div>
      </div>
    </section>
  );
};

export default LiveSection;
